import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADUser entity - alias of ADObject
 * Represents Active Directory user objects
 */
export const adUserEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADUser', display: 'AD User' },
  alias: 'ADObject',
};
